import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'clsx';
import { Logo } from '../../Logo';
import { routeWarmProps } from '@/perf/routePreload';

type RailBrandProps = {
  href: string;
  collapsed?: boolean;
};

export const RailBrand: FunctionComponent<RailBrandProps> = ({ href, collapsed = false }) => (
  <Link
    to={href}
    {...routeWarmProps(href)}
    className={classNames(
      'flex items-center pt-0.5 leading-none text-frost-ink transition-[padding] duration-200 [transition-timing-function:cubic-bezier(0.22,1,0.36,1)]',
      // Contraída: triángulo de 26px y 18px hasta el buscador (que cae a la altura de la flecha).
      collapsed ? 'justify-center px-0 pb-[18px]' : 'px-2.5 pb-3'
    )}
    aria-label="Ir al inicio"
  >
    {collapsed ? (
      <Logo type="triangle" width="30px" height="26px" />
    ) : (
      <Logo type="horizontal" width="110px" height="34px" />
    )}
  </Link>
);
